import { Inject, Injectable } from "@angular/core";
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateChild,
  NavigationExtras,
  CanLoad,
  Route
} from "@angular/router";
import { AuthenticationService } from "./authentication.service";
import { DOCUMENT } from "@angular/common";


@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(
    private authService: AuthenticationService,
    private router: Router,
    @Inject(DOCUMENT) private document: Document
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    let url: string = state.url;
    return this.isAccessible(url);
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    return this.canActivate(route, state);
  }

  canLoad(route: Route): boolean {
    let url = `/${route.path}`;
    return this.isLoadable(url);
  }

  // checkLogin(url: string): boolean {
  //   if (this.authService.isLoggedIn) { return true; }

  //   // Store the attempted URL for redirecting
  //   this.authService.redirectUrl = url;
  //   return false;
  // }

  isAccessible(url: string): boolean {
    if (url === "/" || url.includes('signin')) {
      if (this.authService.isLoggedIn()) {
        if (localStorage.getItem('linkedInUserType')) {
          return true;
        } else if (this.authService.getRole() === "tech_vendor") {
          this.router.navigate(["tech-vendor"]);
        } else if (this.authService.getRole() === "tech_buyer") {
          this.router.navigate(["tech-buyer"]);
        } else if (this.authService.getRole() === "ecosystm_staff") {
          this.router.navigate(["ecosystm-staff/dashboard"]);
        }
        if (this.authService.getRole() === "tech_analyst") {
          this.router.navigate(["tech-analyst/dashboard"]);
        }
        return false;
      } else {
        return true;
      }
    } else if (url.includes("/?")) {
      return true;
    }
  }

  isLoadable(url: string): boolean {

    if (url === '/account') {
      if (this.authService.isLoggedIn()) {
        if (this.authService.getRole() === "tech_vendor") {
          this.router.navigate(["tech-vendor"]);
        } else if (this.authService.getRole() === "tech_buyer") {
          this.router.navigate(["tech-buyer"]);
        } else if (this.authService.getRole() === "ecosystm_staff") {
          this.router.navigate(["ecosystm-staff"]);
        }
        if (this.authService.getRole() === "tech_analyst") {
          this.router.navigate(["tech-analyst"]);
        }
        return false;
      } else {
        return true;
      }
    } else if (url === "/tech-vendor") {
      if (
        this.authService.isLoggedIn() &&
        this.authService.isRoleValid("tech_vendor")
      ) {
        return true;
      } else {
        this.navigateToLogin();
        return false;
      }
    } else if (url === "/tech-buyer") {
      if (
        this.authService.isLoggedIn() &&
        this.authService.isRoleValid("tech_buyer")
      ) {
        return true;
      } else {
        this.navigateToLogin();
        return false;
      }
    } else if (url === "/tech-analyst") {
      if (
        this.authService.isLoggedIn() &&
        this.authService.isRoleValid("tech_analyst")
      ) {
        return true;
      } else {
        this.navigateToLogin();
        return false;
      }
    } else if (url === "/ecosystm-staff") {
      if (
        this.authService.isLoggedIn() &&
        this.authService.isRoleValid("ecosystm_staff")
      ) {
        return true;
      } else {
        this.navigateToLogin();
        return false;
      }
    }
  }

  navigateToLogin() {
    localStorage.setItem('REDIRECT_URL', document.location.hash.replace('#', ''));
    this.router.navigate(["/signin"]);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/auth-guard.service.ts